<template>
  <header :class="{ isLogin: $attrs.isLogin }">
    <div class="container">
      <router-link tag="div" class="logo" to="/dashboard/home"></router-link>
      <div class="user-info">
        <template v-if="!$attrs.isLogin">
          <i class="el-icon-user-solid user"></i>
          <p>欢迎您，{{ userName }}</p>
          <p class="download">
            <span class="line"></span>
            <a
              class="text"
              href="/api/textAndFile/downSynopsis?fileName=海尔i-OID平台用户帮助文档.doc"
              style=" padding: 0 10px;
        color: white;
        text-decoration: none"
              >操作说明书下载</a
            >
            <span class="line"></span>
          </p>
          <p @click="loginOut">退出</p>
        </template>
      </div>
    </div>
  </header>
</template>
<script>
import VueCookie from "../config/util.cookies";
export default {
  inheritAttrs: false,
  data() {
    return {
      userName: ""
    };
  },
  methods: {
    uploadFile() {
      let _this = this;
      _this.$Api.get("/api/textAndFile/downSynopsis", {}).then(response => {});
    },
    loginOut() {
      let _this = this;
      _this
        .$confirm("确定要退出登录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          _this.$cookie.delete("userInfo");
          _this.$cookie.delete("token");
          _this.$cookie.delete("authorities");
          _this.$cookie.delete("access_token");
          // _this.$router.push("/ssoLogin");
          let clientId = VueCookie.get("clientId");
          let redirectUri = VueCookie.get("redirectUri");
          let returnUrl = VueCookie.get("returnUrl");
          let ssoUrl = "https://iam.haier.net/";
          let reloadUrl =
            ssoUrl +
            "?client_id=" +
            clientId +
            "&redirect_uri=&returnUrl=" +
            returnUrl +
            "#/exit";
          window.location.href = reloadUrl;
        });
    }
  },
  created() {
    let _this = this;
    let userInfo = JSON.parse(_this.$cookie.get("userInfo"));
    _this.userName = userInfo.fullName;
  }
};
</script>
<style lang="sass" scoped>
header
  width: 100%
  height: 80px
  box-sizing: border-box
  background-color: rgb(128, 190, 249)
  box-shadow: 0 2px 8px rgb(198, 200, 201)
  margin-bottom: 8px
  border-top: 4px solid rgb(50, 127, 207)
  border-bottom: 2px solid rgb(182, 182, 182)
  &.isLogin
    margin-bottom: 0px
    .container
      width: 980px
      margin: 0 auto
  & > .container
    height: 100%
    box-sizing: border-box
    padding: 10px 15px
    display: flex
    align-items: center
    justify-content: space-between

  .logo
    background: url('../assets/images/logo.jpg') no-repeat
    width: 260px
    min-height: 45px
  .user-info
    box-sizing: border-box
    padding: 10px 0
    height: 80px
    display: flex
    align-items: center
    align-self: flex-start
    .user
      color: white
    & > p:not(:first-child)
      cursor: pointer
    & > p
      padding: 0 10px
      font-size: 14px
      color: white
    p.download
      display: flex
      align-items: center
      span
        display: inline-block
      span.text
        padding: 0 10px
        color: white
        text-decoration: none
      span:not(.text)
        box-sizing: border-box
        display: inline-block
        height: 18px
        width: 2px
        background: rgb(62, 145, 232)
        &:first-child
          border-right: 1px solid white
        &:last-child
          border-left: 1px solid white
</style>
